<template>
  <header>
    <div id="button-links">
      <social-buttons :links="headerText.links" />
    </div>
    <div id="rectangle" :style="{ transform: `translateY(${scrollY * 0.4}px)` }">
      <div id="banner" class="drop-shadow">
        <p>
          <span class="date-place drop-shadow left-date"><i class="pi pi-calendar"></i>{{ headerText.date }}</span><span
            class="date-place drop-shadow"><i class="pi pi-building"></i>{{ headerText.place }}</span>
        </p>
        <p class="drop-shadow">
          <img :src="headerText.logo" alt="CYB3R Days" id="logo" />
        </p>
        <div id="subtitle">
          <div>
            <p class="sub-title glitch-text" :data-text="headerText.subtitle">
              {{ headerText.subtitle }}
            </p>
          </div>
          <div>
            <p class="sub-sub-title glitch-text" data-text="SPOLEČNĚ PROTI KYBERNETICKÝM HROZBÁM">
              SPOLEČNĚ PROTI KYBERNETICKÝM HROZBÁM
            </p>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script scoped>
import SocialButtons from "./SocialButtons.vue";
export default {
  name: "TheHeader",
  props: {
    headerText: Object,
  },
  data() {
    return {
      scrollY: 0,
    };
  },
  components: {
    SocialButtons,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
  },
};
</script>

<style scoped>
* {
  color: white;
}

#button-links {
  text-align: center;
  padding-top: 45px;
}

#subtitle {
  font-size: 30px;
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.09em;
  margin-bottom: 10px;
  line-height: 1.1;
}

.drop-shadow {
  -webkit-filter: drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.1));
}

#banner {
  text-align: center;
  padding-top: 75px;
}

.sub-title {
  text-shadow: 0 0 10px #ff006f;
  font-weight: bold;
}

.sub-sub-title {
  margin-top: 30px;
}

.left-date {
  margin-right: 25%;
}

.date-place {
  letter-spacing: 0.2em;
  font-weight: 700;
  font-size: 19px;
  margin-left: 10px;
  margin-bottom: 8px;
  line-height: 1.7;
}

#rectangle {
  margin-top: 20vh;
  width: 100%;
  height: 45vh;
  border-radius: 100%;
}

i {
  color: rgb(255, 168, 0);
}

.buy-ticket-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 10;
}

.buy-ticket-btn {
  background: linear-gradient(135deg,
      rgb(255, 168, 0) 0%,
      rgb(230, 150, 0) 100%);
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3), 0 0 30px rgba(255, 168, 0, 0.5);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  animation: glow 2s ease-in-out infinite alternate;
}

.buy-ticket-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 168, 0, 0.4), 0 0 40px rgba(255, 168, 0, 0.7);
  background: linear-gradient(135deg,
      rgb(255, 178, 20) 0%,
      rgb(240, 160, 10) 100%);
}

.buy-ticket-btn:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(255, 168, 0, 0.3);
}

@media only screen and (max-width: 900px) {
  #subtitle {
    font-size: 15px;
  }

  .date-place {
    font-size: 15px;
  }

  #logo {
    width: 100%;
  }

  #banner {
    padding-top: 50px;
    filter: none !important;
  }

  #rectangle {
    margin-top: 50%;
    height: 30vh;
  }

  .left-date {
    display: block;
  }

  .buy-ticket-container {
    bottom: 10px;
  }
}

@keyframes glow {
  from {
    box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3),
      0 0 30px rgba(255, 168, 0, 0.5);
  }

  to {
    box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3),
      0 0 40px rgba(255, 168, 0, 0.8);
  }
}
</style>
